export default __webpack_public_path__ + "static/media/gallery_07.bc4a68f4.jpg";